exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".orgChallenges-65751523{width:990px;margin:40px auto 40px auto}\n", ""]);

// Exports
exports.locals = {
	"orgChallenges": "orgChallenges-65751523"
};